import { useState } from "react";

/**
 * UI 相关状态 Hook
 * 包含对话框、面板、加载状态等
 */
const useUIState = () => {
  // 加载/处理状态
  const [isLoading, setIsLoading] = useState(false);
  const [isWaitingResponse, setIsWaitingResponse] = useState(false);
  const [isMessageInputEnabled, setIsMessageInputEnabled] = useState(true);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isSystemResetting, setIsSystemResetting] = useState(false);

  // 面板状态
  const [isBubbleSidebarVisible, setIsBubbleSidebarVisible] = useState(false);
  const [isAISecretaryVisible, setAISecretaryVisible] = useState(false);
  const [isChatPanelVisible, setIsChatPanelVisible] = useState(true);
  const [chatPanelWidth, setChatPanelWidth] = useState(38.2); // 默认聊天面板占38.2%
  const [messagePanelWidth, setMessagePanelWidth] = useState(
    window.innerWidth > 1200 ? 400 : 300
  );
  const [tabsWidth, setTabsWidth] = useState(200);
  const [isMainDragging, setIsMainDragging] = useState(false);

  // 对话框状态
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDetailModalOpen, setIsDetailModalOpen] = useState(false);
  const [isFlowTypeDialogOpen, setIsFlowTypeDialogOpen] = useState(false);
  const [isCourseManagementDialogOpen, setIsCourseManagementDialogOpen] = useState(false);
  const [isYuyanProjectDialogOpen, setIsYuyanProjectDialogOpen] = useState(false);
  const [showHomeworkDialog, setShowHomeworkDialog] = useState(false);
  const [isEditNameModalOpen, setIsEditNameModalOpen] = useState(false);
  const [showAdvancedPasswordDialog, setShowAdvancedPasswordDialog] = useState(false);
  const [digitalHumanOpen, setDigitalHumanOpen] = useState(false);
  const [isSimDialogOpen, setIsSimDialogOpen] = useState(false);
  const [fileExpertDigitalHumanOpen, setFileExpertDigitalHumanOpen] = useState(false);

  // 菜单状态
  const [anchorEl, setAnchorEl] = useState(null);
  const [isFromMenu, setIsFromMenu] = useState(false);
  const [isListArchivesFromMenu, setIsListArchivesFromMenu] = useState(false);

  // 其他 UI 状态
  const [error, setError] = useState(null);
  const [shouldFlash, setShouldFlash] = useState(false);

  // 重置 UI 状态
  const resetUIState = () => {
    setIsLoading(false);
    setIsWaitingResponse(false);
    setIsMessageInputEnabled(true);
    setIsProcessing(false);
    setIsSystemResetting(false);
    setIsBubbleSidebarVisible(false);
    setAISecretaryVisible(false);
    setIsChatPanelVisible(true);
    setChatPanelWidth(38.2);
    setIsMainDragging(false);
    setIsModalOpen(false);
    setIsDetailModalOpen(false);
    setIsFlowTypeDialogOpen(false);
    setIsCourseManagementDialogOpen(false);
    setIsYuyanProjectDialogOpen(false);
    setShowHomeworkDialog(false);
    setIsEditNameModalOpen(false);
    setShowAdvancedPasswordDialog(false);
    setDigitalHumanOpen(false);
    setIsSimDialogOpen(false);
    setFileExpertDigitalHumanOpen(false);
    setAnchorEl(null);
    setIsFromMenu(false);
    setIsListArchivesFromMenu(false);
    setError(null);
    setShouldFlash(false);
  };

  return {
    // 加载/处理状态
    isLoading,
    setIsLoading,
    isWaitingResponse,
    setIsWaitingResponse,
    isMessageInputEnabled,
    setIsMessageInputEnabled,
    isProcessing,
    setIsProcessing,
    isSystemResetting,
    setIsSystemResetting,

    // 面板状态
    isBubbleSidebarVisible,
    setIsBubbleSidebarVisible,
    isAISecretaryVisible,
    setAISecretaryVisible,
    isChatPanelVisible,
    setIsChatPanelVisible,
    chatPanelWidth,
    setChatPanelWidth,
    messagePanelWidth,
    setMessagePanelWidth,
    tabsWidth,
    setTabsWidth,
    isMainDragging,
    setIsMainDragging,

    // 对话框状态
    isModalOpen,
    setIsModalOpen,
    isDetailModalOpen,
    setIsDetailModalOpen,
    isFlowTypeDialogOpen,
    setIsFlowTypeDialogOpen,
    isCourseManagementDialogOpen,
    setIsCourseManagementDialogOpen,
    isYuyanProjectDialogOpen,
    setIsYuyanProjectDialogOpen,
    showHomeworkDialog,
    setShowHomeworkDialog,
    isEditNameModalOpen,
    setIsEditNameModalOpen,
    showAdvancedPasswordDialog,
    setShowAdvancedPasswordDialog,
    digitalHumanOpen,
    setDigitalHumanOpen,
    isSimDialogOpen,
    setIsSimDialogOpen,
    fileExpertDigitalHumanOpen,
    setFileExpertDigitalHumanOpen,

    // 菜单状态
    anchorEl,
    setAnchorEl,
    isFromMenu,
    setIsFromMenu,
    isListArchivesFromMenu,
    setIsListArchivesFromMenu,

    // 其他
    error,
    setError,
    shouldFlash,
    setShouldFlash,

    resetUIState,
  };
};

export default useUIState;
